app.service('warrantyUpsellingPayment', function (loading, validate, modal, accountConfig) {

	const regulationSelectors = {
		'PLATNOSCI': '#payu-regulation',
		'TPAY': '#tpay-regulation',
		'P24': '#p24-regulation'
	};

	let $self, $bankList, $form, $permissions, $agreement, $confirmButton;

	let config,
		selectedPaymentType = null,
		selectedBankId = null,
		paymentOperator = null,
		isRegulationAcceptanceRequired = false;

	function init() {

		config = accountConfig.getData();
		setElements();
		setEvents();
	}

	function setElements() {
		$self = $('#warranty-upselling-payment');
		$bankList = $('.section-bank-list', $self);
		$form = $('#payment-agreement-form', $self);
		$permissions = $('.section-permissions', $self);
		$agreement = $('#payment-agreement', $self);
		$confirmButton = $('.js-confirm-payment', $self);
	}

	function setEvents() {
		$('body')
			.on('click', '.js-select-payment-type', function () {
				$(this).toggleClass('selected')
					.siblings()
					.removeClass('selected');

				selectedPaymentType = $(this).hasClass('selected') ? $(this).data('type') : null;

				$agreement.prop('checked', false);

				selectedBankId = null;
				updateRegulations();
			})
			.on('click', '.js-bank-select', function () {
				$(this).toggleClass('selected')
					.siblings()
					.removeClass('selected');

				if (!$(this).hasClass('selected')) {
					$agreement.prop('checked', false);
					selectedBankId = null;
				} else {
					selectedBankId = $(this).data('bank');
				}

				updateRegulations();
			})
			.on('click', '.js-back-action', function(e) {
				e.preventDefault();
				window.history.back();
			});

		$agreement.on('click', render);

		validate.task('warrantyUpsellingPaymentForm', {
			$form,
			submitHandler() {
				handleConfirmPaymentClick();
			}
		});
	}

	function handleConfirmPaymentClick() {
		loading.start();

		$.ajax({
			url: '/customer-initialize-warranty-upselling-payment.ltr',
			type: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({
				orderNumber: config.orderNumber,
				upsellingId: config.upsellingId,
				paymentType: selectedPaymentType,
				paymentBankId: selectedBankId,
				paymentOperator: paymentOperator
			}),
			success(response) {
				if (response.status === 'SUCCESS') {
					window.location.href = `/konto-platnosc.bhtml?paymentId=${response.paymentId}&type=UPSELLING`;
				} else {
					if (response.failureReason === 'PAYMENT_ALREADY_INITIALIZED') {
						modal.alert("Płatność jest w toku. Zostaniesz przekierowany do listy zamówień. Aby kontynuować, kliknij 'Opłać ochronę sprzętu'.", () => {
							window.location.href = '/customer-current-orders.bhtml';
						});
					} else {
						modal.alert("Wystąpił błąd podczas inicjalizacji płatności. Strona zostanie odświeżona. Spróbuj ponownie lub skontaktuj się z infolinią.", () => {
							window.location.reload();
						});
					}
				}
			},
			error() {
				modal.alert("Wystąpił błąd podczas inicjalizacji płatności. Spróbuj ponownie za chwilę lub skontaktuj się z infolinią.");
			},
			complete() {
				loading.stop();
			}
		})
	}

	function updateRegulations() {

		validate.resetForm($form);

		if (!selectedPaymentType) {
			isRegulationAcceptanceRequired = false;
			selectedBankId = null;
			paymentOperator = null;
			render();
			return;
		}

		if (selectedPaymentType === 'E_TRANSFER' && !selectedBankId) {
			updateOperatorNotice({
				regulationsUrl: '',
				operatorType: null
			});
			render();
			return;
		}

		loading.start();

		$.ajax({
			url: '/customer-warranty-upselling-payment-operator.ltr',
			type: 'POST',
			contentType: 'application/json',
			data: JSON.stringify({
				orderNumber: config.orderNumber,
				upsellingId: config.upsellingId,
				paymentType: selectedPaymentType,
				bankId: selectedBankId
			}),
			success(response) {
				updateOperatorNotice({
					regulationsUrl: response.regulationsUrl,
					operatorType: response.operatorType
				});
				render();
			},
			error() {
				modal.alert("Wystąpił błąd podczas pobierania informacji o płatności. Spróbuj ponownie za chwilę.");
			},
			complete() {
				loading.stop();
			}
		});
	}

	function checkRegulationAcceptanceRequired(response) {
		return selectedPaymentType === 'E_TRANSFER' ||
			response && response.regulationsUrl !== "";
	}

	function render() {

		if (selectedPaymentType) {
			$bankList.toggleClass('is-visible', selectedPaymentType === 'E_TRANSFER');
			$permissions.toggleClass('is-visible', showPermissions());
			$confirmButton.prop('disabled', checkConfirmButtonDisabled());
			$agreement.ignore(!isRegulationAcceptanceRequired);
		} else { // no payment type selected
			$bankList.removeClass('is-visible');
			$permissions.removeClass('is-visible');
			$confirmButton.prop('disabled', true);
			$agreement.ignore(true);
		}
	}

	function checkConfirmButtonDisabled() {
		return !selectedPaymentType || (selectedPaymentType === 'E_TRANSFER' && !selectedBankId);
	}

	function updateOperatorNotice(operatorData) {
		const {regulationsUrl, operatorType} = operatorData;

		isRegulationAcceptanceRequired = checkRegulationAcceptanceRequired(operatorData);
		paymentOperator = operatorType;

		const $operatorNotice = $(regulationSelectors[operatorType]);

		if (regulationsUrl && $operatorNotice.length) {
			$operatorNotice
				.addClass('is-visible')
				.siblings('.operator-notice')
				.removeClass('is-visible');
			$operatorNotice.find('a').attr('href', regulationsUrl);
		}
	}

	function showPermissions() {

		if (selectedPaymentType === 'E_TRANSFER') {
			return $bankList.find('.selected').length !== 0;
		}

		return isRegulationAcceptanceRequired;
	}

	return {
		init
	};
});